// extracted by mini-css-extract-plugin
export default {"container":"FAMRGA","wrapper":"gIFXsZ","listItemMobile":"VbmcXs","pagination":"B4NYD6","separator":"taJz3x"};